// extracted by css-extract-rspack-plugin
export default {"button-wrapper":"dkkpWZ","buttonWrapper":"dkkpWZ","dot":"H1hNgK"};